import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agentFirstnameFilter'
})
export class AgentFirstnameFilterPipe implements PipeTransform {

  transform(value: any[], first_name: string): any[] {
    if (first_name !== '') {
      return value.filter(
        item => item.first_name.toLowerCase().indexOf(first_name.toLowerCase()) > -1)
    } else {
      return value;
    }
  }

}
